<div>
  <h3>{{ title() }}</h3>
  <p>{{ description() }}</p>
  <app-button label="Log in" (click)="logIn()" />
  <p class="link">Don't have an account? <span (click)="logIn()">Sign up</span></p>
</div>
